import FeathersHelper from "../../helpers/feathers";

export const find = (payload) =>
  FeathersHelper.find('interactions', payload);
export const create = (payload) =>
  FeathersHelper.create('interactions', payload);
export const patch = (id, payload, params = {}) => FeathersHelper.patch('interactions', id, payload, params);
export const remove = (id, params = {}) => FeathersHelper.remove('interactions', id, params);

